import { toSnakeCase } from "@/shared/utils/toSnakeCase/toSnakeCase"

type ParamsDict = Record<string, string>

export function addParamsToUrl(url: string, params: ParamsDict): string {
  const u = new URL(url)

  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined && value !== "") {
      u.searchParams.set(toSnakeCase(key), value)
    }
  }
  return u.href
}
